export const StarIcon = ({
  className,
  fill,
}: {
  className?: string;
  fill?: string;
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ""}
    >
      <path
        d="M11.3242 2.63334C11.823 1.68797 13.177 1.68797 13.6758 2.63335L15.8518 6.7578C16.0442 7.12237 16.3948 7.37709 16.8009 7.44737L21.396 8.24242C22.4492 8.42466 22.8676 9.71233 22.1226 10.4788L18.8725 13.8229C18.5852 14.1185 18.4513 14.5307 18.51 14.9387L19.1738 19.5545C19.3259 20.6125 18.2306 21.4083 17.2714 20.9367L13.0866 18.879C12.7167 18.6971 12.2833 18.6971 11.9134 18.879L7.72864 20.9367C6.76943 21.4083 5.67407 20.6125 5.82622 19.5545L6.49003 14.9387C6.5487 14.5307 6.41479 14.1185 6.1275 13.8229L2.87736 10.4788C2.13239 9.71233 2.55078 8.42466 3.60401 8.24242L8.19905 7.44737C8.60522 7.37709 8.95581 7.12237 9.14816 6.7578L11.3242 2.63334Z"
        fill={fill || "var(--swapper-primary-color)"}
      />
    </svg>
  );
};
